module.exports = __webpack_public_path__ + "img/four-section-zsgw.d2c4c5a3.png";